<script>import { createEventDispatcher } from "svelte";
import { _ } from "svelte-i18n";
import SearchIcon from "../../icons/SearchIcon.svelte";
import { cn } from "../../utils/twClnm.js";
const dispatch = createEventDispatcher();
const onInput = (event) => {
  dispatch("input", {
    value: event?.target?.value
  });
};
export let placeholder = $_("general.filter-dropdown.filter");
export let inputClass = "";
export let inputType = "text";
export let value = "";
export let icon = SearchIcon;
</script>

<div
	class={cn(`tw-relative tw-inline-flex 
	tw-h-9 tw-w-[calc(100%-10px)] tw-items-center 
	tw-justify-start tw-gap-2.5 tw-rounded-2xl 
	tw-border tw-border-zinc-200 tw-bg-gray-200 
	tw-px-3 tw-py-2`, $$restProps.class)}
>
	{#if icon}
		<div
			class="tw-pointer-events-none tw-absolute tw-inset-y-0
		tw-left-0 tw-flex
		tw-items-center tw-pl-3"
		>
			<span class="tw-text-gray-500 sm:tw-text-sm"><svelte:component this={icon} /></span>
		</div>
	{/if}
	<input
		type={inputType}
		class={cn(`tw-h-full tw-w-full tw-bg-transparent 
		tw-p-4 tw-pl-5 tw-pr-0 
		tw-text-sm tw-font-medium tw-leading-tight 
		tw-text-gray-500 tw-outline-none`, inputClass)}
		placeholder={placeholder}
		value={value}
		on:input={onInput}
	/>
</div>
